export const getDiscount = (newPrice: number, oldPrice: number): number => {
  if (typeof newPrice === 'number' && typeof oldPrice === 'number') {
    return Math.floor((Math.abs(oldPrice - newPrice) * 100) / oldPrice);
  }
};
